import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, IconButton } from '@material-ui/core';
import { Delete as DeleteIcon } from '@material-ui/icons';
import Image from './Image';

const useStyles = makeStyles((theme) => ({
    imageSelector: {
        display: 'flex',
        overflowX: 'auto',
        gap: theme.spacing(1),
        padding: theme.spacing(1),
    },
    item: {
        textAlign: 'center',
        background: '#f5f5f5',
        borderRadius: theme.shape.borderRadius,
        position: 'relative',
        flexShrink: 0,
    },
    imageWrapper: {
        width: '20rem',
        height: '20rem',
        margin: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: theme.palette.grey[200],
        },
    },
    image: {
        maxHeight: '100%',
        maxWidth: '100%',
        borderRadius: theme.shape.borderRadius,
        transition: 'border 0.2s ease-in-out',
        '&:hover': {
            border: '2px solid #ffdd57',
        },
    },
    selectedImage: {
        border: '4px solid #ff3860',
    },
    deleteIcon: {
        position: 'absolute',
        top: '0.5rem',
        right: '0.5rem',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '50%',
        padding: theme.spacing(0.5),
        cursor: 'pointer',
        color: 'red',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            transform: 'scale(1.1)',
        },
    },
    noImages: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary,
        fontSize: '1.4rem',
    },
}));

const ImageSelector = (props) => {
    const classes = useStyles();

    const handleImageSelect = (image) => {
        props.onSelect(image);
    }

    const handleDeleteImage = (event, image) => {
        event.stopPropagation();
        props.onDelete(image);
    }

    const renderImages = images => {
        if (!images || images.length === 0) {
            return (
                <Box className={classes.noImages}>
                    No Images
                </Box>
            );
        }

        return images.map((image, index) => {
            const isSelected = image.image_id === props.selectedImageId;

            return (
                <Box key={index} className={classes.item}>
                    <Box
                        className={classes.imageWrapper}
                        onClick={() => handleImageSelect(image)}
                    >
                        <Image
                            src={image.image_url}
                            size={'200'}
                            alt={`Image ${index + 1}`}
                            className={`${classes.image} ${isSelected ? classes.selectedImage : ''}`}
                        />
                    </Box>
                    {
                        props.onDelete && (
                            <IconButton
                                className={classes.deleteIcon}
                                onClick={(event) => handleDeleteImage(event, image)}
                                size="small"
                            >
                                <DeleteIcon />
                            </IconButton>
                        )
                    }
                </Box>
            )
        })
    }

    return (
        <Box className={classes.imageSelector}>
            {renderImages(props.images)}
        </Box>
    )
}

ImageSelector.propTypes = {
    onSelect: PropTypes.func,
    onDelete: PropTypes.func,
    images: PropTypes.array,
    selectedImageId: PropTypes.string
}

export default ImageSelector
